import type { EventProps } from './shippers/types';

// Faro event/user attributes must be a flat Record<string, string>. Coerce
// objects/arrays to JSON and primitives to strings; drop nullish values.
export const stringifyEventProps = (props: EventProps): Record<string, string> =>
  Object.entries(props).reduce<Record<string, string>>((acc, [key, value]) => {
    if (value === null || value === undefined) {
      return acc;
    }
    // oxlint-disable-next-line typescript/no-base-to-string -- EventProps is Record<string, unknown> and the object arm of this same ternary sends objects to JSON.stringify
    acc[key] = typeof value === 'object' ? JSON.stringify(value) : String(value);
    return acc;
  }, {});
